<template>
  <div class="search">
      <Form id="formid" ref="form" :model="form" :label-width="100" :rules="formValidate" >        
        <FormItem label="片名" prop="title" >
          <Input v-model="form.title" style="width:100%"/>
        </FormItem>
        <FormItem label="导演" prop="director" >
          <Input v-model="form.director" style="width:100%"/>
        </FormItem>
        <FormItem label="主演" prop="mainStar" >
          <Input v-model="form.mainStar" style="width:100%"/>
        </FormItem>
        <FormItem label="时长" prop="duration">
          <Input type="number" v-model="form.severalNum" style="width:24%;padding:0px 20px 0px 50px;text-align: center;"/>
          集，每集
          <Input type="number" v-model="form.minuteNum" style="width:18%;padding:0 20px;text-align: center;"/>
          分钟，总时长
          <span style="margin:0 30px">{{form.severalNum * form.minuteNum}}</span>分钟
        </FormItem>
        <FormItem label="类型" prop="copyrightType" style="margin-top:30px;" >
          <Select v-model="form.copyrightType" placeholder="请选择" style="width: 200px;margin-left:50px;">
            <Option v-for="(item, i) in dictTime" :key="i" :value="item.value">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem label="上映年份" prop="releaseDate">
            <DatePicker type="year" :clearable="false" v-model="form.releaseDate" style="width:200px;padding:0"></DatePicker>
        </FormItem>
        <FormItem :style="{textAlign:'center'}">
            <Button :loading="submitLoading" style="margin-left:-100px" type="primary" @click="handleSubmit">预计收益测算</Button>
        </FormItem>
      </Form>
  </div>
</template>

<script>
export default {
  name: "profit-assess",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        title: "",
        director: "",
        mainStar: "",
        severalNum: "",
        minuteNum: "",
        duration: "",
        copyrightType: "0",
        releaseDate: "2019",
      },
      dictTime:[
        {value:'0',title:'电影'},
        {value:'1',title:'电视'},
        {value:'2',title:'综艺'},
        {value:'3',title:'动画'},
        {value:'4',title:'Vlog'},
        {value:'5',title:'纪录片'},
        {value:'6',title:'电竞'},
        {value:'7',title:'体育'},
        {value:'8',title:'其他'},
      ],
      // 表单验证规则
      formValidate: {     
      },
      submitLoading: false, // 添加或编辑提交状态
    };
  },
  methods: {
    RandomNum(Min, Max) {
      var Range = Max - Min;
      var Rand = Math.random();
      var num = Min + Math.round(Rand * Range); //四舍五入
      return num;
    },
    init(){
      this.$refs.form.resetFields();
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    handleSubmit() {
      let _this = this
      if(this.form.title == ''){
        this.$Message.error("请输入片名，片名不能为空");
        return false;
      }
      if(this.form.severalNum == '' || this.form.minuteNum == ''){
        this.$Message.error("集数，时长不能为空");
        return false;
      }
      _this.$refs.form.validate(valid => {
        if (valid) {
          var resDate
          _this.submitLoading = true;
          if(_this.form.releaseDate != ''){
            console.log(this.form.releaseDate)
              var d = new Date(_this.form.releaseDate);
              resDate = d.getFullYear();
            //   this.form.releaseDate = resDate
            // console.log(this.form.releaseDate)
              delete _this.form.releaseDate;
          }
          delete _this.form.duration;
          let querychange = {
            releaseDate:resDate,
            duration:_this.form.severalNum * _this.form.minuteNum
          }
          let query = Object.assign(querychange,_this.form)
          console.log('++++++++++++++++++++',query)
          let timeout = _this.RandomNum(3000,5000)
          setTimeout(function(){
            _this.submitLoading = false;
            _this.$router.push({
              name:"profit_assess_detail", // 预估页面
              query:query
            })
          },timeout)
          
          /*
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            if(this.form.releaseDate != ''){
              var d = new Date(this.form.releaseDate);
              var resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              this.form.releaseDate = resDate
            }
            // var resTime = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
            this.postRequest("/incomeBudgetAnalyse/insertOrUpdate", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            this.postRequest("/incomeBudgetAnalyse/insertOrUpdate", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
          */
        }
      });
    },
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
#formid{
    background:#fff;
    width: 800px;
    border-radius: 5px;
    margin: 50px auto;
    padding: 30px;
    .ivu-form-item-error-tip{
      margin-left:50px;
    }
    .ivu-input-wrapper{
      padding:0 50px;
    }
    .ivu-input{
        border:none;
        border-bottom: 1px solid #dcdee2;
        border-radius: unset;
    }
    .ivu-date-picker{
      .ivu-input{
        border:1px solid #dcdee2;
      }
      .ivu-input-wrapper{
        padding:0px;
        margin-left: 50px;
      }
      .ivu-select-dropdown{
        left: 42px !important;
      }
    }
    .ivu-button{
      padding:5px 50px 6px
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
        outline:none;
    }
}
</style>